module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gq-ef40434753c7870159ad18478cf85c95.svg";